var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckCircleFilledGreen = function SvgCheckCircleFilledGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8335,
    cy: 15,
    r: 14.25,
    fill: "#57B7AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.7917,
    height: 19.7917,
    transform: "translate(5.3335 4.70837)",
    fill: "#57B7AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 17.7998L9.14757 14.361L7.97656 15.5237L12.5864 20.1335L22.4822 10.2377L21.3194 9.07495L12.5864 17.7998Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleFilledGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-circle-filled-green.8759cebf458f089ac9f91c2b74fd1f2d.svg";